/* eslint-disable react/no-unknown-property */
import React from "react";
import classNames from "classnames";
import { Tooltip, Icon } from "@tinper/next-ui";
// import { observer } from "mobx-react";

import "./index.less";
const wrapperClassName = "ynf-lib-pro";

export default function hocWithBaseElementWrap (Ctor) {
  const classConst = "yy-base-element-";
  const hocWithLabel = props => {
    let {
      caption,
      // eslint-disable-next-line camelcase
      caption_resid,
      showLabel = true, // 是否显示label——自身设置的——优先级高于从父级继承的hasLabel // 'true':'显示'|'false':'隐藏'
      singleLine = "true", // label的展示样式 horizontal-左右 'vertical'-上下
      hasLabel = true, // 从父容器那边继承的——是否有label
      labelStyle = {}, // label的样式
      contentStyle = {},
      labelAlign = '', // label纵向位置
      wrapStyle = {}, // 外层wrap的样式
      required = false,
      readOnly,
      visible,
      tips,
      errorTips,
      invalid,
      degignDomAttr = {}, // 设计器属性
      designDomClassName = "", // 设计器class
      fieldid,
      fieldidPrefix,
      renderEnv,
      depend = ''
    } = props;

    try { labelStyle = JSON.parse(labelStyle) } catch (error) {}
    try { contentStyle = JSON.parse(contentStyle) } catch (error) {}
    try { wrapStyle = JSON.parse(wrapStyle) } catch (error) {}
    switch (labelStyle.textAlign) {
    case 'left':
      labelStyle.justifyContent = 'flex-start'
      break;
    case 'right':
      labelStyle.justifyContent = 'flex-end'
      break;
    case 'center':
      labelStyle.justifyContent = 'center'
      break;
    default:
      break;
    }
    const labelType = singleLine === "true" ? "horizontal" : "vertical";
    // 判断是否为特征字段，如果是，则默认label背景色
    let dependBgColor = {}
    if (renderEnv === 'designer' && depend !== '') {
      dependBgColor = { background: 'linear-gradient(to right, #10B98180, #10B98100)' }
    }
    // 外层class
    const wrapClass = classNames([
      wrapperClassName,
      `${classConst}wrap`,
      `${labelType}-label`,
      { invalid },
      !readOnly && required ? "wui-form-item-row-required" : "",
      visible === false ? "hidden" : "",
      designDomClassName
    ]);
    // label的class
    const labelClass = classNames([wrapperClassName, `${classConst}label`]);
    // content的class
    let contentClass = classNames([wrapperClassName, `${classConst}content`]);
    if (singleLine === "false") {
      contentClass = classNames([wrapperClassName, `${classConst}content-vertical`]);
    }

    const showTitle = !hasLabel ? false : showLabel;

    return (
      visible !== false && (
        <div {...degignDomAttr} className={wrapClass} style={{ alignItems: `${labelAlign}`, ...wrapStyle }}>
          {showTitle &&
            caption && ( // 有label且有caption
            // eslint-disable-next-line camelcase
            <div langid={caption_resid} placement='top' className={labelClass} title={caption} style={{ ...labelStyle, ...dependBgColor, wordBreak: 'break-word' }}>
              <Icon className="required-star" type="uf-mi" style={{ visibility: !readOnly && required ? 'visible' : 'hidden' }} />
              {caption}
              {// 最终确定, 字段说明作为标题的补充, 隐藏标题时同步隐藏
                tips && (
                  <Tooltip
                    overlayClassName={`${classConst}tooltip-cont`}
                    getPopupContainer={triggerNode => triggerNode.parentNode}
                    overlay={<div style={{ maxWidth: "110px" }}>{tips}</div>}
                    placement="top"
                  >
                    <Icon fieldid={fieldid || `${fieldidPrefix}_tipsIcon`} className="yy-base-element-tipicon" type="uf-a-wenhaomoren" />
                  </Tooltip>
                )}
            </div>
          )
          }
          <div className={contentClass} style={contentStyle} fieldid={`${fieldidPrefix}_content`}>
            <Tooltip
              overlayClassName={`${classConst}tooltip-cont`}
              getPopupContainer={triggerNode => triggerNode.parentNode}
              overlay={<div style={{ width: "110px" }}>{errorTips}</div>}
              placement="top"
              visible={errorTips}
              color="#fff">
              <Ctor {...props} />
            </Tooltip>
          </div>
        </div>
      )
    );
  };
  // return observer(hocWithLabel);
  return hocWithLabel;
}
